import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getUTMParams, saveUTMParams, hasUTMParams } from '../utils/tracking';

/**
 * 追蹤 Hook - 自動處理 UTM 參數和頁面瀏覽
 */
export const useTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // 1. 處理 UTM 參數
    const utmParams = getUTMParams();
    if (hasUTMParams(utmParams)) {
      saveUTMParams(utmParams);
      console.log('UTM 參數已儲存:', utmParams);
    }

    // 2. Google Tag Manager - 頁面瀏覽事件
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }

    // 3. Google Analytics 4 - 頁面瀏覽（如果直接使用 gtag）
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, [location]);
};

/**
 * 追蹤自定義事件
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  // Google Tag Manager
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventParams
    });
  }

  // Google Analytics 4
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }

  console.log('事件追蹤:', eventName, eventParams);
};

/**
 * 追蹤表單提交
 */
export const trackFormSubmit = (formName: string, formData?: Record<string, any>) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...formData
  });
};

/**
 * 追蹤按鈕點擊
 */
export const trackButtonClick = (buttonName: string, buttonLocation?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation
  });
};

/**
 * 追蹤電話點擊
 */
export const trackPhoneClick = (phoneNumber: string) => {
  trackEvent('phone_click', {
    phone_number: phoneNumber
  });
};

/**
 * 追蹤 LINE 點擊
 */
export const trackLineClick = (location?: string) => {
  trackEvent('line_click', {
    click_location: location
  });
};

/**
 * 追蹤轉換事件
 */
export const trackConversion = (conversionType: string, value?: number) => {
  trackEvent('conversion', {
    conversion_type: conversionType,
    value: value
  });

  // Google Ads 轉換追蹤（需要設定轉換 ID）
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17711376638/CONVERSION_LABEL', // 請替換為實際的轉換標籤
      value: value,
      currency: 'TWD'
    });
  }
};

// TypeScript 類型定義
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
